import { ref, onMounted } from 'vue'

interface Country {
  name: {
    common: string;
  };
  cca2: string;
  flags: {
    svg: string;
  };
  idd: {
    root: string;
    suffixes?: string[];
  };
}

interface FormattedCountry {
  code: string;
  label: string;
  value: string;
  flag: string;
  name: string;
  displayName: string;
}

export const useCountries = () => {
  const countries = ref<FormattedCountry[]>([])
  const isLoading = ref(true)
  const error = ref<Error | null>(null)

  const fetchCountries = async () => {
    try {
      isLoading.value = true
      const data = await $fetch<Country[]>('/data/countries.json')
      countries.value = data
        .filter(country => country.idd?.root && country.name?.common) // Filter out invalid data
        .map(country => {
          const code = country.idd.root + (country.idd.suffixes?.[0] || '')
          return {
            code,
            label: code, // For the selected state
            value: code,
            flag: country.flags.svg,
            name: country.name.common,
            displayName: `${country.name.common} (${code})` // For the dropdown
          }
        })
        .sort((a, b) => a.name.localeCompare(b.name))
    } catch (err) {
      error.value = err instanceof Error ? err : new Error('Failed to fetch countries')
      console.error('Error fetching countries:', err)
    } finally {
      isLoading.value = false
    }
  }

  onMounted(() => {
    fetchCountries()
  })

  return {
    countries,
    isLoading,
    error,
    fetchCountries
  }
} 